import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { REDUX_CACHE, ROLES, HTTP_METHOD } from '../constants';
import {
  getBaseQuery,
  getListProvidesTags,
  TransformedErrorResponseWithNotification,
} from '../generic';
import { IRole } from '../../../types/interfaces/role';

export const rolesApi = createApi({
  reducerPath: 'rolesApi',
  tagTypes: [ROLES.ROLES, REDUX_CACHE.ABORT_INVALIDATION, REDUX_CACHE.LIST],
  baseQuery: getBaseQuery('/admin/roles'),
  // global configuration for the api
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getRolesApi: builder.query<IRole[], void>({
      keepUnusedDataFor: 3600,
      query() {
        return {
          url: '',
          method: HTTP_METHOD.GET,
        };
      },
      providesTags: (result) => getListProvidesTags(result, ROLES.ROLES),
      ...TransformedErrorResponseWithNotification(),
    }),
  }),
});

export const { useGetRolesApiQuery: useGetRoles } = rolesApi;
